import { FC, useMemo } from 'react';

import { BreakdownsResult, EMetric, metricDictionary, StatsResult } from 'api/useAnalytics';
import Decimal from 'decimal.js';
import {
  EStatisticType
} from 'views/Statistics/StatisticsView.types';

import Typography from 'components/Typography/Typography';

import { AnalyticsIndicator } from '../AnalyticsIndicator';
import { AnalyticsInfoTooltip } from '../AnalyticsInfoTooltip/AnalyticsInfoTooltip';

  const NO_DATA_VALUE = 'N/A';


type AnalyticsBoxHeaderProps = {
  stat?: StatsResult;
  metricName: EMetric;
  breakdown?: BreakdownsResult;
};

export const AnalyticsBoxHeader: FC<AnalyticsBoxHeaderProps> = ({
  stat,
  metricName,
  breakdown,
}) => {
  const metricMetaData = metricDictionary[metricName];
  const metricType = metricMetaData?.type ?? EStatisticType.NUMBER;
  const currentValue = useMemo(() => {
    if (metricType === EStatisticType.AMOUNT_AVERAGE) {
      const decimalValue = new Decimal(stat?.currentValue ?? 0);
      return decimalValue.div(100).toNumber();
    }
    return stat?.currentValue;
  }, [stat, metricType]);

  if (metricMetaData === undefined) {
    return null;
  }

  const shouldDisplayEmptyState = (breakdown?.values?.length === 0 || breakdown?.values?.length === undefined) && !currentValue 

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-[10px]">
        <Typography className="text-base-cardForeground font-semibold">
          {metricMetaData.title}
        </Typography>
        <AnalyticsInfoTooltip>
          {metricMetaData.description}
        </AnalyticsInfoTooltip>
      </div>
      {shouldDisplayEmptyState && <Typography tag="h2" className="text-base-cardForeground mt-3 mb-1.5">{NO_DATA_VALUE}</Typography>}
        {!breakdown && !shouldDisplayEmptyState && <AnalyticsIndicator 
        currentValue={currentValue} 
        metricType={metricType} 
        changePercentage={stat?.changePercentage}
        />}
    </div>
  );
};
